import { z } from 'zod'

import { dbEntitySchema } from './system'

export const authCredentialSchema = dbEntitySchema.extend({
  password: z.string(),
  user: z.string().nullish(),
  managementUser: z.string().nullish(),
  resetToken: z.string().nullish(),
  resetTokenExpires: z.date().nullish(),
  resetCode: z.string().nullish(),
  resetCodeExpires: z.date().nullish(),
  resetCodeAttempts: z.number().nullish(),
  emailVerificationToken: z.string().nullish(),
  emailVerificationTokenExpires: z.date().nullish(),
})
